import { useLayoutEffect } from "react";

let holders = 0;
let savedOverflow = "";
let savedGutter = "";

function acquire() {
  if (holders++ > 0) return;
  const root = document.documentElement;
  savedOverflow = document.body.style.overflow;
  savedGutter = root.style.scrollbarGutter;
  if (window.innerWidth > root.clientWidth) root.style.scrollbarGutter = "stable";
  document.body.style.overflow = "hidden";
}

function release() {
  if (holders === 0 || --holders > 0) return;
  document.body.style.overflow = savedOverflow;
  document.documentElement.style.scrollbarGutter = savedGutter;
}

/**
 * Locks page scroll while the layer is open; ref-counted, so stacked layers (category + item modal)
 * may release in any order and the page unlocks only when the last one closes.
 */
export function useLockBodyScroll(open: boolean) {
  useLayoutEffect(() => {
    if (!open) return;
    acquire();
    return release;
  }, [open]);
}
